import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { bulkPublishQuestions } from "../../redux/vaultQuestions/vaultQuestionThunks";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { Icon } from "@iconify/react/dist/iconify.js";

const BulkPublishButton = ({ selectedItems, refreshList, clearSelection }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleBulkPublish = async () => {
    try {
      setLoading(true);
      const ids = selectedItems.length ? selectedItems : [];

      const res = await dispatch(bulkPublishQuestions({ ids })).unwrap();

      // Case 1: Backend error or no eligible questions
      if (Number(res.status) === 0) {
        const skipped = res.skippedQuestions?.length || 0;
        setErrorMessage(
          skipped > 0
            ? `No eligible questions to publish.`
            : res.message || "No eligible questions to publish."
        );
        return;
      }

      // Normalize fields
      const published = res.updatedQuestions || [];
      const skipped = res.skippedQuestions || [];

      // Case 2: Published successfully
      if (published.length > 0) {
        setSuccessMessage(
          `${published.length} questions published successfully!`
        );
        refreshList?.();
        clearSelection?.();
        return;
      }

      // Case 3: Only skipped
      if (skipped.length > 0) {
        setErrorMessage(`No eligible questions to publish.`);
        return;
      }

      // Case 4: Nothing
      setErrorMessage("No eligible questions to publish.");
    } catch (err) {
      setErrorMessage(err?.message || "Bulk publish failed.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);
  return (
    <>
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}

      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}

      <button
        onClick={handleBulkPublish}
        disabled={loading || selectedItems.length === 0}
        className="btn btn-primary bulk-edit-btn text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
      >
        {loading ? (
          "Publishing..."
        ) : (
          <>
            <Icon
              icon="mdi:publish"
              className="icon text-xl line-height-1"
              width="24"
              height="24"
            />{" "}
            Bulk Publish
          </>
        )}
      </button>
    </>
  );
};

export default BulkPublishButton;
